import { postReminderClick } from '../api/emailApi';

/** rid — id строки журнала писем (UUID), другое бэкенд отвергнет. */
const RID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const SENT_KEY = 'lx.reminderClick';

/** id письма из ссылки напоминания (`utm_medium=reminder&rid=…`) или null. */
export function reminderClickId(search: string): string | null {
  const params = new URLSearchParams(search);
  const rid = params.get('rid')?.trim() ?? '';
  return params.get('utm_medium') === 'reminder' && RID.test(rid) ? rid : null;
}

/**
 * Засчитать клик по ссылке из письма — при старте приложения, до входа: гость уходит на /auth,
 * а клик был. Один раз на письмо в этой вкладке (перезагрузка не шлёт повтор); сбой сети молча
 * пропускается — это только отчёт о доле кликов.
 */
export function reportReminderClick(search: string): void {
  const rid = reminderClickId(search);
  if (!rid) return;
  try {
    if (window.sessionStorage.getItem(SENT_KEY) === rid) return;
    window.sessionStorage.setItem(SENT_KEY, rid);
  } catch {
    // хранилище заблокировано — отправим без защиты от повтора
  }
  postReminderClick(rid).catch(() => undefined);
}
